var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:{ 'layout--min-width': _vm.overrideMobileWarning }},[_c('Toast'),_vm._v(" "),_c('SystemDialog'),_vm._v(" "),_c('SessionManagementNotification'),_vm._v(" "),_c('nuxt')],1)}
var staticRenderFns = []

export { render, staticRenderFns }